
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class CompanyEmailService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('CompanyEmail');
	}

	loadAll(): Observable<TooBig4Car.Logic.CompanyEmail[]> {
		return this.myBaseService.loadAll(this.url);
	}
	save(tempItem: TooBig4Car.Logic.CompanyEmail): Observable<TooBig4Car.Logic.CompanyEmail> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.CompanyEmail> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid): Observable<TooBig4Car.Logic.CompanyEmail> {
		return this.myBaseService.get(id, this.url);
	}
	resend(id: System.Guid): Observable<string> {
		return this.myBaseService.post(null, this.url + '/Resend/' + (id || ''), false);
	}
}

